import $ from 'jquery';
import toastr from 'toastr';
import { I18n } from "i18n-js";
const i18n = new I18n();

import { onSemestersPickersChange } from './semesters';
import { addCriterium } from './addMoreCriterium';
import { editAndDeleteButtons } from './allCriteria';
import { checkboxChange } from './eventsCriteria';

$(document).ready(function() {
  var $seeConfigurationsButton = $('#seeConfigurations');
  var $selectPartner = $('.select-partner-config-js');
  var $selectSecretaries = $('.select-secretaries-config-js');
  var $selectYears = $('.select-year-config-js');
  $seeConfigurationsButton.click(function() {
    var partnerId = $('.select-partner-config-js option:selected').val();
    var secretaryId = $('.select-secretaries-config-js option:selected').val();
    var year = $('.select-year-config-js option:selected').val();

    if (partnerId == "" || secretaryId == "" || year == "") {
      toastr.warning(i18n.t('views.configs.school_year.warning.must_select_partner'));
      return;
    }

    $selectPartner.prop('disabled', true);
    $selectSecretaries.prop('disabled', true);
    $selectYears.prop('disabled', true);

    findAllConfigurations(partnerId, secretaryId, year);
  });
});

function findAllConfigurations(partnerId, secretaryId, selectYears) {
  $.ajax({
    method: 'GET',
    url: './configs/find_configurations',
    data: {
      secretary_id: secretaryId,
      partner_id: partnerId,
      year: selectYears,
    },
    success: function(data) {
      $('#showConfiguration').html(data);
      $('.btn-save-js').removeClass('d-none');
      $('.btn-fixed-save-js').removeClass('d-none');
      $('.input-group.date.semesters-picker').datepicker({
        language: "pt-BR",
        clearBtn: true
      });
      onSemestersPickersChange();
      addCriterium();
      checkboxChange();
      editAndDeleteButtons();
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

